import EmailIcon from "@mui/icons-material/Email";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

const NOTIFICATIONS_ICONS = {
  validation_requested: AssignmentTurnedInIcon,
  other: EmailIcon,
};

export default NOTIFICATIONS_ICONS;
